import { render, staticRenderFns } from "./QCReport.vue?vue&type=template&id=11512d7a&scoped=true"
import script from "./QCReport.vue?vue&type=script&lang=js"
export * from "./QCReport.vue?vue&type=script&lang=js"
import style0 from "./QCReport.vue?vue&type=style&index=0&id=11512d7a&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11512d7a",
  null
  
)

export default component.exports